import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Card, makeStyles, CardContent, Typography } from '@material-ui/core';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import SearchBox from '../../../../components/table/SearchBox';
import DataTable from '../../../../components/table/Table';
import FormDialog from '../../../../components/table/FormDialog';
import { CommonConfig } from '../../../../config/common-config';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../../components/loaderpopup/success';
import ErrorPopUp from '../../../../components/loaderpopup/error';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    width60: {
        maxWidth: '60% !important',
        flexBasis: '60% !important',
    },
    width40: {
        maxWidth: '40% !important',
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
        margin: '0px 0px 10px 14px !important',
    },
    popFoot: {
        justifyContent: 'flex-start',
    },
    textMessage: {
        fontFamily: 'Rubik',
        marginBottom: '0px !important',
    }
}));

function IndividualClientsITeC(props) {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [rows, setTotalReactPackages] = useState([]);
    const [deletedata, setDeleteData] = useState(rows);
    const [searchQuery, setSearchQuery] = useState('');
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const dbname = tennantDetails.tennantName;
    const [selectedImc] = useState(location.state.domainname);
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [confirmView, setConfirmView] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);

    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const handleClose = () => {
        setSuccessPop(false);
        setErrorPop(false);
    };

    const headCells = [
        { id: 'iclientId', label: 'Client ID' },
        { id: 'firstName', label: 'Name' },
        { id: 'primarycontEmailid', label: 'Email' },
        { id: 'primarycontMobnumber', label: 'Phone' },
        {
            id: 'addressId',
            label: 'Address',
            isConcat: 'true',
            concatElem: ['addressLine1', 'addressLine2', 'city', 'stateId.stateName', 'country'],
        },
    ];

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };
    const getAdminListData = () => {
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Ind/${selectedImc}?page=${page}&size=10&sort=dateModified,desc`,
                axiosConfig
            )
            .then((response) => {
                setTotalReactPackages(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => { });
    };

    useEffect(() => {
        getAdminListData();
    }, [deletedata, userToken, page, selectedImc, dbname]);

    const getSearchValueAdmin = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Ind/${selectedImc}?search=${data}&page=${page}&size=10&sort=firstName,asc`, axiosConfig)
            .then((res) => {
                if (res.data) {
                    console.log('responseresponse11', res);
                    if (res.data.content.length === 0) {
                        setTotalReactPackages([]);
                    }
                    // formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getAdminListData();
        // getCandidatesBYUser();
        // console.log('clearclear')
    }

    const handleSearchQuery = (data) => {
        // setSearchQuery(searchData);
        setSearchQuery(data);
        // console.log('data', data);
        if (data && data.length > 2) {
            setPage(0)
            setNoRecordCount(false);
            getSearchValueAdmin(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getAdminListData();
        }
    };

    // const handleSearchQuery = (data) => {
    //     setSearchQuery(data);
    // };

    const handleSave = () => { };

    const deleteIMCType = (data, value) => {
        setShowLoader(true);
        if (data.iclientId) {
            axios
                .delete(`${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Ind/${value}/${data.iclientId}`, axiosConfig)
                .then((response) => {
                    //console.log("response=>handleDelete", response);
                    const { status } = response;
                    if (status === 200) {
                        const list = rows.filter((m) => m.iclientId !== data.iclientId);
                        setDeleteData({ rows: list });
                        // setDeleteMsg('Client deleted successfully');
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            setSuccessPop(false);
                        }, 3000);
                    }
                })
                .catch((e) => {
                    setShowLoader(false);
                    if (e && e.response && e.response.data && e.response.data.message) {
                        setConfirmView(true);
                        setErrorMessage(e.response.data.message)
                    } else {
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                    }
                });
        }
    };
    const handleDelete = (data) => {
        if (usertype !== 'SUPERADMIN') {
            deleteIMCType(data, dbname);
        } else {
            deleteIMCType(data, selectedImc);
        }
    };
    const navigate = () => {
        let domainname = selectedImc;
        console.log("domainname", domainname);
        history.push({
            pathname: '/menu/ClientIndividualCreate',
            state: { domainname },
        });
    };

    const back = () => {
        props.history.push({
            pathname: '/menu/ClientIndividualView',
        });
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Client deleted successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}

            <Dialog
                open={confirmView}
                onClose={() => setConfirmView(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            >
                {/* <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Confirmation
                </DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.textMessage}>
                        {errorMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => setConfirmView(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        Ok
                    </Button>
                    {/* <Button onClick={proceedToTax} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        Ok
                    </Button> */}
                </DialogActions>
            </Dialog>

            <Card className="custom-table mb10">
                {filteredRow.length > 0 ? (
                    <>
                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Individual Clients List</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                </div>
                                <div className="card-add-button">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        onClick={navigate}
                                        className={classes.button}
                                    >
                                        Create Client
                                    </Button>
                                </div>
                            </Grid>
                            <FormDialog row={[]} saveRow={handleSave} pageName="individual" show="AddIcon" />
                        </CardContent>
                        <CardContent className="card-table-display">
                            <DataTable
                                rows={filteredRow}
                                headCells={headCells}
                                saveRow={handleSave}
                                pageName="individual"
                                handleDelete={handleDelete}
                                action
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            />
                        </CardContent>
                    </>
                ) : (
                        <div>
                            <CardContent className="card-title-display">
                                <Grid item xs={12} sm={8}>
                                    <Typography className="card-title">Individual Clients List</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} className="card-search">
                                    <div className="search-field">
                                        <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                    </div>
                                    <div className="card-add-button">
                                        <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                                            Create Client
                                    </Button>
                                    </div>
                                </Grid>
                            </CardContent>
                            <CardContent className="card-table-display">
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            </CardContent>
                        </div>
                    )}
            </Card>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
                </Button>
        </>
    );
}

export default IndividualClientsITeC;

